module.exports = __webpack_public_path__ + "static/media/Logo_2.a1a311fd.png";